import { useEffect, useState } from 'react';
import { formatDepositRemaining } from '@/calendar/depositCountdown';

export function DepositCountdown({ expiresAt }: { expiresAt: string | null | undefined }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!expiresAt) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);

  if (!expiresAt) return null;
  const label = formatDepositRemaining(expiresAt, now);
  if (!label) return null;
  const expired = label === 'Seña vencida';

  return (
    <span className={expired ? 'pwa-deposit-countdown pwa-deposit-countdown--expired' : 'pwa-deposit-countdown'}>
      {label}
    </span>
  );
}
